export default "__VITE_ASSET__7af81caf__"